import Reveal from '@/components/base/Reveal';

export default function EntryCTA() {
  return (
    <section id="entry" className="py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-background-200">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20field%20of%20flowing%20paper%20ribbons%20in%20deep%20vermillion%20amber%20and%20cream%20tones%2C%20soft%20grain%20texture%2C%20minimal%20editorial%20background%2C%20no%20text%2C%20wide%20cinematic%20composition%2C%20harmonious%2C%20high%20detail&width=1600&height=620&seq=hl-entry-cta&orientation=landscape"
                alt="进入44黑料区引导背景图"
                title="44黑料区 黑料汇总 入口"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-foreground-950/55" />

            <div className="relative flex flex-col items-start gap-8 px-6 py-14 md:flex-row md:items-center md:justify-between md:px-16 md:py-20">
              <div className="max-w-xl">
                <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium text-background-50">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-apps-2-line text-xs" />
                  </span>
                  一键直达 · 无需翻页
                </span>
                <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                  想看最新的黑料汇总，
                  <br className="hidden md:block" />
                  现在就从这里进去
                </h2>
                <p className="mt-4 text-sm leading-7 text-background-100">
                  聚合、梳理、更新全在同一个入口完成。收藏本站，下次直接打开就能看到当天新增的热点爆料。
                </p>
              </div>

              <div className="flex w-full flex-col gap-3 sm:flex-row md:w-auto md:shrink-0 md:flex-col">
                <a
                  href="#featured"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-fire-line text-base" />
                  进入黑料区
                </a>
                <a
                  href="#ranking"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-8 py-4 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-download-2-line text-base" />
                  收藏 / 添加到桌面
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}